export default __webpack_public_path__ + "static/media/custom2w.74b0ef02.png";